module.exports = __webpack_public_path__ + "img/browser6.a1d0ce91.png";